export const FETCH_DAILY_HILL_SCORE_DATA_REPORTS = 'FETCH_DAILY_HILL_SCORE_DATA_REPORTS';
export const FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING = 'FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING';
export const FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS = 'FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS';
export const FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL = 'FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL';
export const FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS =
    'FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS';

export const FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS = 'FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS';
export const FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING = 'FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING';
export const FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS = 'FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS';
export const FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL = 'FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL';

export const FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS = 'FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS';
export const FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING = 'FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING';
export const FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS = 'FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS';
export const FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL = 'FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL';
